import ApiHelper from "../restapi/ApiHelper"
const baseUrl = "http://127.0.0.1:8181/api"
export const NativeRestApi = {
    getConversations: async () => {
        const result: any = await ApiHelper.get(`${baseUrl}/getConversations`)
        return result.data
    },
    getAllMessages: async () => {
        const result: any = await ApiHelper.get(`${baseUrl}/getAllMessages`)
        return result.data
    },
    getAllMessagesByConv: async (id:number) => {
        const result: any = await ApiHelper.get(`${baseUrl}/getAllMessagesByConv?threadId=${id}`)
        return result.data
    }
}